export const buttonsOptions = [
    {id: "squadflix", name: "Squadflix", home: true},
    {id: "squadflix-live", name: "Squadflix Live"},
    {id: "squadflix-search", name: "Squadflix Search"},
    {id: "drive", name: "Drive", home: true},
    {id: "home", name: "Inicio", home: true},
    //{id: "firulais", name: "Firulais AI"},
    {id: "profile-info", name: "Perfil"},
    {id: "groups", name: "Grupos"},
]
